import { createContext } from "react";
import createClient, { BridgeClient } from "../clients/BridgeApi";

export const BridgeClientContext = createContext<BridgeClient | null>(null);